import { createFileRoute } from "@tanstack/react-router";
import { DashboardShell, PlaceholderCard } from "@/components/DashboardShell";
import { SUPER_ADMIN_NAV } from "@/lib/nav";

export const Route = createFileRoute("/_authenticated/super-admin/complaints")({
  head: () => ({
    meta: [
      { title: "Complaints · Landoo Super Admin" },
      { name: "description", content: "Complaints — Landoo super admin console." },
    ],
  }),
  component: () => (
    <DashboardShell title="Complaints" role="Super Admin" items={SUPER_ADMIN_NAV}>
      <PlaceholderCard
        title="Complaints"
        description="Super admin management surface for Complaints."
      />
    </DashboardShell>
  ),
});
